var UITooltip = (function ($) {

    UITooltip = function () {
        var that = this;

        // CONST
        that.class = {
            is_active: 'is-tooltip-active',
            click: 'js-tooltip-click',
            hover: 'js-tooltip-hover',
            wrapper: 'js-tooltip-wrapper'
        };

        // INIT
        that.init();
    };

    UITooltip.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UITooltip.prototype.tooltipClick = function (button) {
        var that = this,
            $button = $(button),
            $wrapper = $button.parents('.' + that.class.wrapper),
            target = $button.data('tooltip-for');

        if (!$button.hasClass(that.class.is_active)) {
            that.hideAll();
            $button.addClass(that.class.is_active);
            that.show($wrapper, target);
        } else {
            $button.removeClass(that.class.is_active);
            that.hide($wrapper, target);
        }
    };

    UITooltip.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('click', '.' + that.class.click, function (e) {
            e.preventDefault();
            that.tooltipClick($(this));
        });

        $.sa.$document.on('click touchstart', function (e) {
            var $target = $(e.target);

            if (
                !$target.hasClass(that.class.click) &&
                !$target.parents('.' + that.class.click).length &&
                !$target.hasClass(that.class.hover) &&
                !$target.parents('.' + that.class.hover).length
            ) {
                that.hideAll();
            }
        });

        $.sa.$document.keyup(function(e){
            if (e.key === 'Escape') {
                that.hideAll();
            }
        });

        if (!$.sa.is_touch()) {
            $.sa.$document.on('mouseenter', '.' + that.class.hover, function (e) {
                var $button = $(this),
                    $wrapper = $button.parents('.' + that.class.wrapper),
                    target = $button.data('tooltip-for');

                that.hideAll();

                $button.addClass(that.class.is_active);
                that.show($wrapper, target);
            });

            $.sa.$document.on('mouseleave', '.' + that.class.hover, function (e) {
                var $button = $(this),
                    $wrapper = $button.parents('.' + that.class.wrapper),
                    target = $button.data('tooltip-for');

                $button.removeClass(that.class.is_active);
                that.hide($wrapper, target);
            });
        } else {
            $.sa.$document.on('click', '.' + that.class.hover, function (e) {
                e.preventDefault();
                that.tooltipClick($(this));
            });
        }
    };

    UITooltip.prototype.show = function ($wrapper, target) {
        var that = this,
            target_selector = '[data-tooltip-id="' + target + '"]';

        $wrapper.find(target_selector).parents('.tooltip-wrapper').addClass(that.class.is_active);
    };

    UITooltip.prototype.hide = function ($wrapper, target) {
        var that = this,
            target_selector = '[data-tooltip-id="' + target + '"]';

        $wrapper.find(target_selector).parents('.tooltip-wrapper').removeClass(that.class.is_active);
    };

    UITooltip.prototype.hideAll = function () {
        var that = this;

        $.sa.$document.find('.' + that.class.click).removeClass(that.class.is_active);
        $.sa.$document.find('.' + that.class.hover).removeClass(that.class.is_active);
        $.sa.$document.find('.tooltip-wrapper').removeClass(that.class.is_active);
    };

    return UITooltip;
})($);